import { ElementRef } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatPaginator, MatSort } from '@angular/material';
import { ObservableMedia } from '@angular/flex-layout';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { debounceTime } from 'rxjs/operators/debounceTime';
import { distinctUntilChanged } from 'rxjs/operators/distinctUntilChanged';
import { first } from 'rxjs/operators/first';
import { fromEvent } from 'rxjs/observable/fromEvent';
import { merge } from 'rxjs/observable/merge';
import { Subject } from 'rxjs/Subject';
import { takeUntil } from 'rxjs/operators/takeUntil';
import { isBefore, isDate, isValid } from 'date-fns';
import { DataTableSource } from '../../classes/DataTableSource/datatablesource';
import { ApplicationService } from '../../services/application/application.service';
import { ErrorService } from '../../services/error/error.service';
import { UserService } from '../../services/user/user.service';
var StudentSearchComponent = /** @class */ (function () {
    function StudentSearchComponent(appService, errorService, fb, mediaChange, route, router, userService) {
        this.appService = appService;
        this.errorService = errorService;
        this.fb = fb;
        this.mediaChange = mediaChange;
        this.route = route;
        this.router = router;
        this.userService = userService;
        this._subRelease = new Subject();
        // Class
        this.AllHeaders = ['StudentID', 'LastName', 'FirstName', 'MiddleName', 'School', 'Grade', 'Actions'];
        this.AvailableSchoolGrades = ['All', '06', '07', '08', '09', '10', '11', '12'];
    }
    StudentSearchComponent.prototype.ngAfterViewInit = function () {
        var self = this;
        // Observe for key presses on the search fields
        var firstev = fromEvent(this.firstinput.nativeElement, 'keyup').pipe(takeUntil(self._subRelease), debounceTime(150), distinctUntilChanged());
        var lastev = fromEvent(this.lastinput.nativeElement, 'keyup').pipe(takeUntil(self._subRelease), debounceTime(150), distinctUntilChanged());
        var stuidev = fromEvent(this.studentidinput.nativeElement, 'keyup').pipe(takeUntil(self._subRelease), debounceTime(150), distinctUntilChanged());
        merge(firstev, lastev, stuidev)
            .pipe(takeUntil(self._subRelease))
            .subscribe(function (keystroke) {
            if (keystroke.keyCode === 13) {
                // User hit an ENTER. Perform search.
                // self.HandleSearch();
            }
        });
    };
    StudentSearchComponent.prototype.ngOnDestroy = function () {
        this._subRelease.next();
        this._subRelease.complete();
    };
    StudentSearchComponent.prototype.ngOnInit = function () {
        var self = this;
        self.AvailableSchools = null;
        self.HasAnyUpcoming = false;
        self.PartialViewReady = false;
        self.ReferrerSource = null;
        self.SearchConducted = false;
        self.SearchResults = null;
        self.SelectedSchoolYear = null;
        self.ShowSearch = true;
        self.SearchData = new DataTableSource(self.SearchResults, self.paginator, self.sorter, self.SortStudents.bind(self));
        self.SmallDisplay = self.mediaChange.isActive('xs') || self.mediaChange.isActive('sm');
        self.mediaChange
            .asObservable()
            .pipe(takeUntil(self._subRelease))
            .subscribe(function (media) {
            self.SmallDisplay = media.mqAlias === 'xs' || media.mqAlias === 'sm';
            self.VisibleHeaders = self.SmallDisplay ? ['SmallDisplay'] : self.AllHeaders.slice();
            self.VisibleColumns = self.VisibleHeaders.slice();
            self.ShowSearch = self.SmallDisplay ? !self.SearchConducted : true;
        });
        self.SearchForm = self.fb.group({
            FirstName: [''],
            LastName: [''],
            StudentID: [''],
            Grade: [''],
            CollegeID: [null],
            CollegeStudentID: [''],
            Term: [''],
            SchoolNumber: [''],
        }, {
            validator: function (ctrl) {
                if (!ctrl) {
                    return null;
                }
                var form = ctrl.value;
                if (!form.FirstName &&
                    !form.LastName &&
                    !form.StudentID &&
                    !form.Grade &&
                    !form.CollegeID &&
                    !form.CollegeStudentID &&
                    !form.Term &&
                    !form.SchoolNumber) {
                    return { noneprovided: true };
                }
                if (!form.StudentID &&
                    !form.Grade &&
                    !form.CollegeID &&
                    !form.CollegeStudentID &&
                    !form.Term &&
                    !form.SchoolNumber) {
                    // Check to make sure we have at least 5 characters combined from the firstname and lastname fields
                    var fn = (form.FirstName || '').length;
                    var ln = (form.LastName || '').length;
                    if (fn + ln < 5) {
                        return { TooFewCharacters: true };
                    }
                }
                return null;
            },
        });
        // Wait for a first non-null User result before kicking off the page
        self.userService.UserSubject.pipe(takeUntil(self._subRelease), first(function (item) { return item && !!item.AuthToken; })).subscribe(function (_user) {
            self.User = _user;
            // Hook into items which can change (such as parameters or user authtoken updates)
            combineLatest(self.userService.UserSubject, self.route.params, self.appService.SelectedSchoolYearSubject, self.appService.GetAllSchools(self.User.AuthToken), function (user, params, selYear, schools) {
                return {
                    User: user,
                    Params: params,
                    SelectedYear: selYear,
                    Schools: schools,
                };
            })
                .pipe(takeUntil(self._subRelease))
                .subscribe(function (packet) {
                self.User = packet.User;
                self.ReferrerSource = packet.Params['Source'];
                self.SelectedSchoolYear = packet.SelectedYear;
                self.AvailableSchools = packet.Schools;
                // Set the page as ready
                self.PartialViewReady = true;
            }, function (error) {
                self.errorService.HandleServiceError(error);
            });
        });
    };
    // #region Clear Form Method
    StudentSearchComponent.prototype.ClearForm = function () {
        this.SearchForm.reset();
        this.firstinput.nativeElement.focus();
    };
    // #endregion
    // #region Handle Search Method
    StudentSearchComponent.prototype.HandleSearch = function () {
        var self = this;
        // If the current user is not a district admin or developer, then default the school number in the search to their work location.
        var searchParams = self.SearchForm.value;
        if (!self.User.IsDistrictAdmin && !self.User.IsDeveloper) {
            searchParams.SchoolNumber = self.User.SchoolNumber;
        }
        // Call to get the search results ('0937' - test school)
        self.appService
            .SearchForStudent(self.User.AuthToken, self.User.CurrentRole, self.SelectedSchoolYear, searchParams.SchoolNumber, searchParams.StudentID, searchParams.CollegeID, searchParams.Term, self.SelectedSchoolYear, searchParams.Grade, searchParams.FirstName, searchParams.LastName)
            .subscribe(function (results) {
            self.SearchResults = results;
            if (self.SmallDisplay) {
                self.ShowSearch = false;
            }
            self.HasAnyUpcoming = false;
            if (self.SearchResults && self.SearchResults.length) {
                var upcoming = self.SearchResults.find(function (item) {
                    return item.UpcomingSchoolYear === true;
                }) != null;
                self.HasAnyUpcoming = upcoming;
                self.VisibleHeaders = self.SmallDisplay ? ['SmallDisplay'] : self.AllHeaders.slice();
                self.VisibleColumns = self.VisibleHeaders.slice();
            }
            else {
                self.VisibleColumns = ['NoData'];
            }
            self.SearchData.Update(self.SearchResults);
            self.SearchConducted = true;
        }, function (error) {
            self.errorService.HandleServiceError(error);
        });
    };
    // #endregion
    // #region Show Search Form Method
    StudentSearchComponent.prototype.ShowSearchForm = function () {
        this.ShowSearch = true;
        this.SearchConducted = false;
    };
    // #endregion
    // #region Sort Students Method
    StudentSearchComponent.prototype.SortStudents = function (First, Second) {
        var self = this;
        var PropA;
        var PropB;
        switch (self.sorter.active) {
            case 'StudentID':
                _a = [First.StudentID, Second.StudentID], PropA = _a[0], PropB = _a[1];
                break;
            case 'LastName':
                _b = [First.LastName, Second.LastName], PropA = _b[0], PropB = _b[1];
                break;
            case 'FirstName':
                _c = [First.FirstName, Second.FirstName], PropA = _c[0], PropB = _c[1];
                break;
            case 'MiddleName':
                _d = [First.MiddleName, Second.MiddleName], PropA = _d[0], PropB = _d[1];
                break;
            case 'School':
                _e = [First.SchoolName, Second.SchoolName], PropA = _e[0], PropB = _e[1];
                break;
            case 'Grade':
                _f = [First.GradeLevel, Second.GradeLevel], PropA = _f[0], PropB = _f[1];
                break;
        }
        if (isDate(PropA)) {
            if (!isDate(PropB)) {
                return 0;
            }
            if (!isValid(PropA) || !isValid(PropB)) {
                return 0;
            }
            if (isBefore(PropA, PropB)) {
                return -1 * (self.sorter.direction === 'asc' ? 1 : -1);
            }
            if (isBefore(PropB, PropA)) {
                return 1 * (self.sorter.direction === 'asc' ? 1 : -1);
            }
            return 0;
        }
        else {
            var ValueA = PropA != null && PropA !== '' ? (isNaN(+PropA) ? PropA : +PropA) : PropA;
            var ValueB = PropB != null && PropB !== '' ? (isNaN(+PropB) ? PropB : +PropB) : PropB;
            return (ValueA < ValueB ? -1 : 1) * (self.sorter.direction === 'asc' ? 1 : -1);
        }
        var _a, _b, _c, _d, _e, _f;
    };
    // #endregion
    // #region View Student Method
    StudentSearchComponent.prototype.ViewStudent = function (student) {
        if (!student) {
            return;
        }
        // Route to the student view
        this.router.navigate(['/studentview', student.StudentID]);
    };
    return StudentSearchComponent;
}());
export { StudentSearchComponent };
// #region Custom Classes
// #region Search Result Class
var SearchResult = /** @class */ (function () {
    function SearchResult() {
    }
    return SearchResult;
}());
export { SearchResult };
// #endregion
// #endregion



// WEBPACK FOOTER //
// ./src/app/studentsearch/studentsearch.component.ts.pre-build-optimizer.js